import "./movements.css";

import { Card, Modal, Tabs } from "@sede-x/shell-ds-react-framework";
import { TMovement } from "ticketing/ticketing.types";
import { MovementComments } from "./MovementComments";
import { MovementDebugInfo } from "./MovementDebugInfo";
import { MovementInfoFields } from "./MovementInfoFields";

const MovementAdditionalDetailsContainer = ({
  movement,
  onClose
}: {
  movement: TMovement;
  onClose: () => void;
}) => {
  const handleClose = () => onClose();

  return (
    <Modal
      open={true}
      contentScrollable
      onClose={handleClose}
      bodyPadding={false}
      title={`Delivery ID: ${movement?.enterpriseSystemCode}`}>
      <Card className="movement-aspect-container" bodyPadding={false}>
        <Tabs
          items={[
            {
              label: "Info",
              key: "A",
              className: "tab-content-small",
              children: <MovementInfoFields movement={movement} onClose={onClose} />
            },
            {
              label: "Comments",
              key: "B",
              className: "tab-content-small",
              children: <MovementComments movement={movement} onClose={onClose} />
            },
            {
              label: "Debug Info",
              key: "C",
              className: "tab-content-large",
              children: <MovementDebugInfo movement={movement} onClose={onClose} />
            }
          ]}
        />
      </Card>
    </Modal>
  );
};

export default MovementAdditionalDetailsContainer;
